const SortOrders = {
	ASC: 'asc',
	DESC: 'desc'
};

export {
	SortOrders
};
